import { Group, Paper, Skeleton, Table } from '@mantine/core';
import { ReactElement } from 'react';

export function PartnersPageSkeleton(): ReactElement {
  return (
    <Paper shadow="sm" withBorder style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Table highlightOnHover>
        <Table.Thead p="xs">
          <Table.Tr>
            <Table.Th fw={500} w="20%">
              Organization
            </Table.Th>
            <Table.Th fw={500} w="20%">
              Type
            </Table.Th>
            <Table.Th fw={500} w="20%">
              Phone
            </Table.Th>
            <Table.Th fw={500} w="20%">
              Email
            </Table.Th>
            <Table.Th fw={500} w="15%">
              Contacts
            </Table.Th>
            <Table.Th fw={500} w="5%"></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {Array.from({ length: 7 }).map((_, index) => (
            <Table.Tr key={index} p="xs">
              <Table.Td>
                <Skeleton h={22} w="60%" />
              </Table.Td>
              <Table.Td>
                <Skeleton h={18} w={60} radius="xl" />
              </Table.Td>
              <Table.Td>
                <Skeleton h={20} w={120} />
              </Table.Td>
              <Table.Td>
                <Skeleton h={20} w="70%" />
              </Table.Td>
              <Table.Td>
                <AvatarSkeletonStack />
              </Table.Td>

              <Table.Td>
                <Skeleton h={29} w={39} radius="lg" />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}

export function AvatarSkeletonStack() {
  // Random number of contacts between 0 and 4
  const randomCount = Math.floor(Math.random() * 5);

  return (
    <Group gap={0} style={{ marginLeft: -6 }}>
      {Array.from({ length: randomCount }).map((_, i) => (
        <Skeleton
          key={i}
          height={30}
          width={30}
          circle
          style={{
            marginLeft: i === 0 ? 0 : -8, // overlap each circle
            border: '2px solid var(--mantine-color-body)',
          }}
        />
      ))}
      {randomCount === 0 ? '-' : ''}
    </Group>
  );
}
